import { memo, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WATCHLIST_GRID_INDEX } from "../../utils/global_variables";
import { getPutCallMasterData } from "../../redux/actions/marketOverview";
import { Row, Col, Stack, Container } from "react-bootstrap";
import ZeroStates from "../ZeroStates";
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  BarElement,
  CategoryScale,
  LinearScale,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';

// Register Chart.js components
ChartJS.register(BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend);


const PutCallRatio = () => {
    const [filteredPutCall, setFilteredPutCall] = useState([]);
    const [toggle, setToggle] = useState([]);
    const dispatch = useDispatch();
    const scripOverviewData = useSelector((state) => state.marketOverview.scripOverviewData);
    const putCallMasterData = useSelector((state) => state.marketOverview.putCallMasterData);
    const [activeTabKey, setActiveTabKey] = useState('Price');
    useEffect(() => {
        const objPayload = {
            symbol: scripOverviewData[WATCHLIST_GRID_INDEX.SYMBOL],
            jtenantToken: 1,
            mktSegmentId: scripOverviewData[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID]
        };
        dispatch(getPutCallMasterData(objPayload));
    }, [scripOverviewData, dispatch]);
    useEffect(() => {
        if (activeTabKey === 'Volume') {
            setToggle('Volume');
        }
        if (activeTabKey === 'OI') {
            setToggle('OI');
        }
        if (activeTabKey === 'Price') {
            setToggle('Price');
        }
        if (activeTabKey === 'VI') {
            setToggle('VI');
        }
    }, [activeTabKey]);
    useEffect(() => {
        // Vaibhav Singh: BT-109095:04-01-24:Logic Changed: Start
        if (putCallMasterData.length) {
            let filteredDataPutCall = [];
            let PutCallData = [];
            // let PEDataVals={}
            // let CEDataVals={}
            for (let index = 0; index < putCallMasterData?.length; index++) {
                PutCallData?.push(JSON?.parse(putCallMasterData[index]));
            }
            //console.log(PutCallData)
            let arrDistinctStrikePrice = [...new Set(PutCallData?.map(item => item?.nStrikePrice))];
            for (let i = 0; i < arrDistinctStrikePrice?.length; i++) {
                let CEdata = PutCallData?.filter(x => x.sOptionType === "CE" && x.nStrikePrice === arrDistinctStrikePrice[i]);
                if (CEdata?.length) {
                    var CEDataVals = {
                        "Price_CE": CEdata[0]?.nLastTradedPrice,
                        "Volume_CE": CEdata[0]?.nTotalQtyTraded,
                        "OI_CE": CEdata[0]?.nOpenInterest,
                        "VI_CE": CEdata[0]?.nImpliedVolatility,
                        "StrikePrice": arrDistinctStrikePrice[i]
                    };
                }
                let PEdata = PutCallData?.filter(x => x.sOptionType === "PE" && x.nStrikePrice === arrDistinctStrikePrice[i]);
                if (PEdata?.length) {
                    var PEDataVals = {
                        "Price_PE": PEdata[0]?.nLastTradedPrice,
                        "Volume_PE": PEdata[0]?.nTotalQtyTraded,
                        "OI_PE": PEdata[0]?.nOpenInterest,
                        "VI_PE": PEdata[0]?.nImpliedVolatility,
                        "StrikePrice": arrDistinctStrikePrice[i]
                    };
                }
                filteredDataPutCall?.push({ ...CEDataVals, ...PEDataVals });
                CEDataVals = {};
                PEDataVals = {};
            }
            setFilteredPutCall(filteredDataPutCall);
            // Vaibhav Singh: BT-109095:04-01-24:Logic Changed: End
        }
    }, [putCallMasterData]);
    // const options = {
    //     data: filteredPutCall?.length ? filteredPutCall : [],
    //     series: [
    //         {
    //             type: "column",
    //             xKey: "StrikePrice",
    //             yKey: `${toggle}_PE`,
    //             yName: 'Put',
    //             fill: "#6fa9e2",
    //         },
    //         {
    //             type: "column",
    //             xKey: 'StrikePrice',
    //             yKey: `${toggle}_CE`,
    //             yName: 'Call',
    //             fill: "#464983"
    //         }
    //     ],
    //     // Vaibhav Singh: BT-109095: 09-11-2023:Legend to circle added  : Start
    //     legend: {
    //         item: {
    //             marker: {
    //                 shape: 'circle'
    //             }
    //         }
    //     }
    //     // Vaibhav Singh: BT-109095: 09-11-2023:Legend to circle added  : End
    // };
    
  // Function to prepare chart data dynamically based on the selected category
  const getChartData = () => {
    return {
      labels:filteredPutCall.map((item) => item.StrikePrice), // Strike Prices on x-axis
      datasets: [
        {
          label:'Call',
          data:filteredPutCall.map((item) => item[`${toggle}_CE`]),
          backgroundColor:"#464983",
          borderColor:'black',
          borderWidth: 1,
          barPercentage:.6, // Make bars thinner
          datalabels: {
            display: false, // Hide labels on the bars
          },
        },
        {
          label:'Put',
          data:filteredPutCall.map((item) => item[`${toggle}_PE`]),
          backgroundColor: "#6fa9e2",
           borderColor:'black', 
          borderWidth: 1,
          barPercentage:.6, // Make bars thinner
          datalabels: {
            display: false, // Hide labels on the bars
          },
        },
      ],
    };
  };

  // Tooltips customizations to only show Strike Price and Value (no color box)
  const tooltipOptions = {
    backgroundColor: 'white', // Set background color of the tooltip to white
    titleColor: 'black', // Title color for tooltip
    bodyColor: 'black', // Body color for tooltip text
    callbacks: {
        title:function(){
            return ''
        },
      label: function (tooltipItem) {
        const label = tooltipItem.raw;
        return `Strike Price: ${tooltipItem.label}, Value: ${label.toFixed(2)}`;
      },
    },
    displayColors: false, // Disable the color boxes beside the tooltip text
  };

  // Chart options
  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: 'bottom', // Legend at the bottom
      },
      tooltip: tooltipOptions, // Apply custom tooltip options
    },
    scales: {
        y:{
            ticks:{
                maxTicksLimit:5
            }
        },
      x: {
        // title: {
        //   display: true,
        //   text: 'Strike Price',
        // },
      },
    },
    backgroundColor: 'white', // Set background color to white
  };
    return (
        <Container data-testid="analysis-fando-put-call-ratio-section" fluid className='p-0'>
            <div className='scripoverview-fieldset'>
                <div className='scripoverview-fieldset-md'>
                    <div className='scripoverview-legend'>PUT CALL RATIO</div>

                    <Row className='g-0 mt-3'>
                        <Col>
                            <div className='submenu-wrapper pb-2'>
                                <Stack direction="horizontal" className='d-flex justify-content-start submenu-wrapper pb-3'>
                                    <div data-testid="analysis-fando-put-call-ratio-price-tab" className={`submenuItem ${activeTabKey === 'Price' ? "active" : ""}`} onClick={() => { setActiveTabKey('Price'); }} tabKey='Price'>Price</div>
                                    <div data-testid="analysis-fando-put-call-ratio-volume-tab" className={`submenuItem ${activeTabKey === 'Volume' ? "active" : ""}`} onClick={() => { setActiveTabKey('Volume'); }} tabKey='Volume'>Volume</div>
                                    <div data-testid="analysis-fando-put-call-oi-tab" className={`submenuItem ${activeTabKey === 'OI' ? "active" : ""}`} onClick={() => { setActiveTabKey('OI'); }} tabKey='OI'>OI</div>
                                    <div data-testid="analysis-fando-put-call-vi-tab" className={`submenuItem ${activeTabKey === 'VI' ? "active" : ""}`} onClick={() => { setActiveTabKey('VI'); }} tabKey='VI'>VI</div>    {/* Bhagyashri P [20-11-2023] : BT-109095 Scrip Overview Analysis classes */}
                                </Stack>
                            </div>
                        </Col>
                    </Row>

                    <div className='so-putcallratio-height'>
                        {(filteredPutCall?.length) ?
                            <div style={{ height: '250px' }}>
                                <div className='font-regular font-size2 color-subtext ps-3'>{activeTabKey}</div>
                                <Bar data-testid="analysis-fando-put-call-ratio-bar-chart" data={getChartData()} options={chartOptions} />
                                <div className='font-regular font-size2 color-subtext text-center mb-2'>Strike Price</div>
                            </div>
                            : <div className='zero-state-alerts zero-state-alerts-lg'>
                                <ZeroStates subText="Could not find any data" icon='icon-64 icon-nodata mb-3 mrgauto' />
                            </div>
                        }
                    </div>

                </div>
            </div>
        </Container>

    );
};
export default memo(PutCallRatio);